// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/Phiro/banner-top-phiro-meritus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/Phiro/front-rear-view-meritus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/Phiro/Phiro-mob-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phiro-accessories {
  background-color: #f5f6fb;
}
.play-phiro {
  background-color: #f5f6fb;
}

.phiro-banner-top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 28.1vw;
}

.heading-npgs span {
  color: var(--dPink);
}

.about-phiro-icons {
  border-right: 1px solid #000;
  padding: 0 5%;
}
.txt-about-phiro {
  /* padding: 0 10%; */
  text-align: justify;
}

.about-icons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 10px;
}
.about-phiro-icons img {
  height: 120px;
  width: 120px;
}

.phiro-variants img {
  /* padding: 0 5%; */
  height: auto;
  width: 100%;
}

/* Card  */
.mbp-cards {
  border: medium none currentColor !important;
  border: initial !important;
}
.mbp-card-img {
  height: 200px;
  width: 220px;
  margin: 0 auto;
}

.mbp-card-title {
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
}

.mbp-card-body {
  padding: 3% 5%;
  text-align: justify;
}

/* Play with Phiro  */
.icon-text-wrapper {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  column-gap: 35px;
}

.play-icons img {
  height: 50px;
  width: 50px;
}
.play-txt {
  font-weight: 600;
}

.play-txt p {
  margin-bottom: 0px;
}

/* USP cards  */
.phiro-usps {
  background-color: #f5f6fb;
}
.usp-card {
  background-color: transparent;
}

.usp-card-img {
  height: 200px;
  width: 300px;
}

.usp-card-body {
  padding: 3% 10% !important;
}

.usp-card-icon {
  padding: 0 10% 5% 10%;
  height: auto;
  width: 100%;
}

/* Phiro Accessories  */
.accessories-img-b img {
  height: auto;
  width: 100%;
  margin-top: -60px;
}

.accessories-img-caption,
.accessories-img-caption-b {
  font-size: 14px;
  font-weight: 500;
}

.accessories-text p {
  font-weight: 600;
}

.accessories-img-caption-b {
  padding-top: 20px;
}

/* Phiro front view and rear view acccessories  */
.front-rear-view-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 32.4vw;
}

.accessories-text p {
  font-size: 14px;
}

/* Phiro includes  */
.inclusion-card {
  text-align: center;
  color: #fff;
  padding: 15px;
  border-radius: 10px;
}

.inclusion-card p {
  font-size: 25px;
  margin-bottom: 0px !important;
  line-height: 1.2;
}

.ic-a {
  background-color: var(--dPink);
  padding: 15px 60px;
}

.ic-b {
  background-color: #0166ae;
}

.ic-c {
  background-color: #00a451;
}

.ic-d {
  background-color: #a2228f;
}

/* Testimonial section  */
.ptc-img img {
  height: 125px;
  width: auto;
}

.phiro-testimonial-txt p {
  padding: 0 30px;
  font-weight: 500;
}

.designation {
  font-weight: 300;
}

.ptc-right-border::after {
  content: "";
  position: absolute;
  background-color: #000;
  width: 2px;
  height: 250px;
  top: 20%;
  right: 0;
}

.client-name-info-wrapper {
  margin-top: 20px;
}

.phiro-testimonial-txt {
  height: 140px;
}

.designation {
  padding: 0 30px;
}

@media (max-width: 576px) {
  .accessories-img-b img {
    margin-top: 10px;
  }
}

@media (max-width: 1024px) {
  .about-phiro-icons {
    border: medium none currentColor;
    border: initial;
    padding-bottom: 20px;
  }

  .txt-about-phiro {
    padding: 0;
    padding: initial;
  }

  .accessories-img-b {
    margin-top: 5%;
  }

  .front-rear-view-banner {
    height: 25vh;
  }

  .inclusion-card {
    margin-bottom: 20px;
  }

  .ptc-right-border::after {
    content: normal;
    content: initial;
  }

  .phiro-testimonial-txt {
    height: 180px;
  }

  .phiro-testimonial-txt p {
    padding: 0;
    padding: initial;
  }

  .ptc-img img {
    height: 105px;
    width: auto;
  }

  .mbp-card-body {
    padding: 0;
    padding: initial;
  }
}

@media (max-width: 576px) {
  .phiro-banner-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 127.1vw;
  }
  .pbm {
    padding-bottom: 0px;
  }

  .ptm {
    padding-top: 0px;
  }

  .about-phiro-icons {
    border-right: 0;
    border-right: initial;
  }

  .txt-about-phiro {
    padding: 0px;
  }

  .about-icons {
    padding-top: 10px;
  }

  .about-phiro-icons img {
    height: 80px;
    width: 80px;
  }

  .phiro-variants {
    padding-top: 30px;
  }

  .more-about-phiro-cards {
    padding-top: 0px;
  }

  .icon-text-wrapper {
    padding: 10px 0px;
  }

  .swish-card {
    padding-top: 20px;
  }

  .usp-card-b {
    padding-top: 10px;
  }

  .usp-card-c {
    padding-top: 20px;
  }

  .accessories-img-b {
    margin-top: 0px;
  }

  .inclusion-card {
    margin: 10px 30px;
  }

  .phiro-testimonial-txt {
    height: auto;
  }

  .inclusion-cards-row {
    margin: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/phiro/Phiro.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAqF;EACrF,wBAAwB;EACxB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA,UAAU;AACV;EACE,2CAAwB;EAAxB,0BAAwB;AAC1B;AACA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,yDAAoF;EACpF,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gCAAa;IAAb,eAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;AACF;;AAEA;EACE;IACE,yDAA6E;IAC7E,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAmB;IAAnB,qBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".phiro-accessories {\n  background-color: #f5f6fb;\n}\n.play-phiro {\n  background-color: #f5f6fb;\n}\n\n.phiro-banner-top {\n  background-image: url(\"../../../../public/images/Phiro/banner-top-phiro-meritus.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 28.1vw;\n}\n\n.heading-npgs span {\n  color: var(--dPink);\n}\n\n.about-phiro-icons {\n  border-right: 1px solid #000;\n  padding: 0 5%;\n}\n.txt-about-phiro {\n  /* padding: 0 10%; */\n  text-align: justify;\n}\n\n.about-icons {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding-top: 10px;\n}\n.about-phiro-icons img {\n  height: 120px;\n  width: 120px;\n}\n\n.phiro-variants img {\n  /* padding: 0 5%; */\n  height: auto;\n  width: 100%;\n}\n\n/* Card  */\n.mbp-cards {\n  border: unset !important;\n}\n.mbp-card-img {\n  height: 200px;\n  width: 220px;\n  margin: 0 auto;\n}\n\n.mbp-card-title {\n  text-align: center;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.mbp-card-body {\n  padding: 3% 5%;\n  text-align: justify;\n}\n\n/* Play with Phiro  */\n.icon-text-wrapper {\n  display: flex;\n  /* justify-content: center; */\n  align-items: center;\n  column-gap: 35px;\n}\n\n.play-icons img {\n  height: 50px;\n  width: 50px;\n}\n.play-txt {\n  font-weight: 600;\n}\n\n.play-txt p {\n  margin-bottom: 0px;\n}\n\n/* USP cards  */\n.phiro-usps {\n  background-color: #f5f6fb;\n}\n.usp-card {\n  background-color: transparent;\n}\n\n.usp-card-img {\n  height: 200px;\n  width: 300px;\n}\n\n.usp-card-body {\n  padding: 3% 10% !important;\n}\n\n.usp-card-icon {\n  padding: 0 10% 5% 10%;\n  height: auto;\n  width: 100%;\n}\n\n/* Phiro Accessories  */\n.accessories-img-b img {\n  height: auto;\n  width: 100%;\n  margin-top: -60px;\n}\n\n.accessories-img-caption,\n.accessories-img-caption-b {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.accessories-text p {\n  font-weight: 600;\n}\n\n.accessories-img-caption-b {\n  padding-top: 20px;\n}\n\n/* Phiro front view and rear view acccessories  */\n.front-rear-view-banner {\n  background-image: url(\"../../../../public/images/Phiro/front-rear-view-meritus.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 32.4vw;\n}\n\n.accessories-text p {\n  font-size: 14px;\n}\n\n/* Phiro includes  */\n.inclusion-card {\n  text-align: center;\n  color: #fff;\n  padding: 15px;\n  border-radius: 10px;\n}\n\n.inclusion-card p {\n  font-size: 25px;\n  margin-bottom: 0px !important;\n  line-height: 1.2;\n}\n\n.ic-a {\n  background-color: var(--dPink);\n  padding: 15px 60px;\n}\n\n.ic-b {\n  background-color: #0166ae;\n}\n\n.ic-c {\n  background-color: #00a451;\n}\n\n.ic-d {\n  background-color: #a2228f;\n}\n\n/* Testimonial section  */\n.ptc-img img {\n  height: 125px;\n  width: auto;\n}\n\n.phiro-testimonial-txt p {\n  padding: 0 30px;\n  font-weight: 500;\n}\n\n.designation {\n  font-weight: 300;\n}\n\n.ptc-right-border::after {\n  content: \"\";\n  position: absolute;\n  background-color: #000;\n  width: 2px;\n  height: 250px;\n  top: 20%;\n  right: 0;\n}\n\n.client-name-info-wrapper {\n  margin-top: 20px;\n}\n\n.phiro-testimonial-txt {\n  height: 140px;\n}\n\n.designation {\n  padding: 0 30px;\n}\n\n@media (max-width: 576px) {\n  .accessories-img-b img {\n    margin-top: 10px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .about-phiro-icons {\n    border: unset;\n    padding-bottom: 20px;\n  }\n\n  .txt-about-phiro {\n    padding: unset;\n  }\n\n  .accessories-img-b {\n    margin-top: 5%;\n  }\n\n  .front-rear-view-banner {\n    height: 25vh;\n  }\n\n  .inclusion-card {\n    margin-bottom: 20px;\n  }\n\n  .ptc-right-border::after {\n    content: unset;\n  }\n\n  .phiro-testimonial-txt {\n    height: 180px;\n  }\n\n  .phiro-testimonial-txt p {\n    padding: unset;\n  }\n\n  .ptc-img img {\n    height: 105px;\n    width: auto;\n  }\n\n  .mbp-card-body {\n    padding: unset;\n  }\n}\n\n@media (max-width: 576px) {\n  .phiro-banner-top {\n    background-image: url(\"../../../../public/images/Phiro/Phiro-mob-banner.jpg\");\n    height: 127.1vw;\n  }\n  .pbm {\n    padding-bottom: 0px;\n  }\n\n  .ptm {\n    padding-top: 0px;\n  }\n\n  .about-phiro-icons {\n    border-right: unset;\n  }\n\n  .txt-about-phiro {\n    padding: 0px;\n  }\n\n  .about-icons {\n    padding-top: 10px;\n  }\n\n  .about-phiro-icons img {\n    height: 80px;\n    width: 80px;\n  }\n\n  .phiro-variants {\n    padding-top: 30px;\n  }\n\n  .more-about-phiro-cards {\n    padding-top: 0px;\n  }\n\n  .icon-text-wrapper {\n    padding: 10px 0px;\n  }\n\n  .swish-card {\n    padding-top: 20px;\n  }\n\n  .usp-card-b {\n    padding-top: 10px;\n  }\n\n  .usp-card-c {\n    padding-top: 20px;\n  }\n\n  .accessories-img-b {\n    margin-top: 0px;\n  }\n\n  .inclusion-card {\n    margin: 10px 30px;\n  }\n\n  .phiro-testimonial-txt {\n    height: auto;\n  }\n\n  .inclusion-cards-row {\n    margin: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
